import interactionParserUtils from './InteractionParserUtils';
import { parseImage } from '../MediaModels';
import constants from '../../../Constants';
import HotSpotService from '../../../../services/questionView/HotSpotService';

const EXTRA_RESPONSE_IDENTIFIER = constants.extraResponseIdentifiers.HOTSPOT_INTERACTION.pointer;

const hotSpotParser = {
    parse(interactionNode, language, defaultLanguage, responseDeclarations, assessmentRunId, mediaInfo) {
        const idPrefix = interactionNode.getAttribute('responseIdentifier');
        const objectElements = interactionNode.getElementsByTagName('object');
        const objects = Array.from(objectElements)
            .map(element => parseImage(idPrefix, element, assessmentRunId));
        const hotSpotAreas = interactionParserUtils
            .parseListOfChildren(interactionNode, 'hotspotChoice', language, defaultLanguage)
            .filter(hotspot => hotspot.identifier !== HotSpotService.getDefaultWrongChoiceIdentifier());
        const markHotspots = interactionNode.getAttribute('class').includes('markHotspots');
        const interactionHeight = interactionNode.getAttribute('inspera:canvasHeight');
        const extraResponseDeclarations = responseDeclarations.filter(x => x.identifier === EXTRA_RESPONSE_IDENTIFIER);
        const prompt = interactionParserUtils.getPrompt(interactionNode, language, defaultLanguage);
        const backgroundImageModel = interactionParserUtils.getBackgroundImageModel(interactionNode, assessmentRunId, mediaInfo);
        const cardinality = responseDeclarations.find(x => x.identifier === idPrefix).cardinality;
        const maxChoices = cardinality === 'single' ? 1 : Number.parseInt(interactionNode.getAttribute('maxChoices'), 10);
        const regardUnansweredOutsideHotspot = extraResponseDeclarations.length === 0;
        const borderColor = interactionNode.getAttribute('data-shape-color') || false;
        const backgroundOpacity = interactionNode.getAttribute('data-shape-opacity') || false;
        const hotspotColoringEnabled = interactionNode.getAttribute('data-hotspot-coloring-enabled') === 'true';

        if (regardUnansweredOutsideHotspot) {
            extraResponseDeclarations.push({
                baseType: 'point',
                cardinality,
                identifier: EXTRA_RESPONSE_IDENTIFIER,
            });
        }

        return {
            backgroundImageModel,
            prompt,
            objects,
            hotSpotAreas,
            markHotspots,
            interactionHeight,
            regardUnansweredOutsideHotspot,
            extraResponseDeclarations,
            cardinality,
            maxChoices,
            borderColor,
            backgroundOpacity,
            hotspotColoringEnabled,
        };
    },
};

export default hotSpotParser;
